import { Bifrost } from "./bifrost";
import parseCookie from "./helpers/parse-cookie";

let bifrostInstance = null;

export const bifrostConfig = {
    authApiBaseUrl: process.env.BIFROST_AUTH_SERVICE_BASE_URL,
    configApiBaseUrl: process.env.BIFROST_CONFIG_SERVICE_BASE_URL,
    clientId: process.env.BIFROST_CLIENT_ID,
    deviceId: parseCookie("bifrost_device_id") || parseCookie("statsigStableId") || "",
    redirectUri: process.env.BIFROST_REDIRECT_URI
};

export const getBifrostInstance = () => {
    if (bifrostInstance) {
        return bifrostInstance;
    } else {
        bifrostInstance = new Bifrost({
            clientId: bifrostConfig.clientId,
            authApiBaseUrl: bifrostConfig.authApiBaseUrl,
            deviceId: bifrostConfig.deviceId,
            redirectUri: bifrostConfig.redirectUri
        });

        return bifrostInstance;
    }
};

// Convenience export for call-sites that want direct access to the singleton instance.
export const bifrost = getBifrostInstance();
